import { createSelector } from 'reselect';
import { reportsCampaigns } from 'store/saga/entities/bound';
import { selectActiveVenue, selectActiveVenueId, selectRouteQuery } from 'selectors/general';

import subDays from 'date-fns/subDays';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

const DATE_FORMAT = 'yyyy-MM-dd';

export const selectCampaignsReportStartDateString = createSelector(
  selectRouteQuery,
  ({ thirtyOneDaysAgo = subDays(new Date(), 31), startDate = format(thirtyOneDaysAgo, DATE_FORMAT) }) => startDate
);

export const selectCampaignsReportEndDateString = createSelector(
  selectRouteQuery,
  ({ today = new Date(), endDate = format(subDays(today, 1), DATE_FORMAT) }) => endDate
);

export const selectCampaignsReportStartDate = createSelector(selectCampaignsReportStartDateString, startDateString =>
  parse(startDateString, DATE_FORMAT, subDays(new Date(), 31))
);

export const selectCampaignsReportEndDate = createSelector(selectCampaignsReportEndDateString, endDateString =>
  parse(endDateString, DATE_FORMAT, subDays(new Date(), 1))
);

export const selectCampaignsReportCampaignTypeId = createSelector(
  selectRouteQuery,
  ({ campaignTypeId }) => campaignTypeId
);

const selectReportsCampaignsEntity = createSelector(
  state => state,
  selectCampaignsReportStartDateString,
  selectCampaignsReportEndDateString,
  selectActiveVenueId,
  selectCampaignsReportCampaignTypeId,
  (state, startDate, endDate, venueId, campaignTypeId) =>
    reportsCampaigns.select(state, reportsCampaigns.defaultKey(null, { campaignTypeId, startDate, endDate, venueId }))
);

export const selectReportsCampaigns = createSelector(
  selectReportsCampaignsEntity,
  selectActiveVenue,
  ({ data, error, loaded, loading }, { currencyCode, venueId, venueName, venueSubtitle }) => ({
    data: (loaded ? data : []).map(reservation => {
      const { discountPercentage, rate, userFirstName, userLastName } = reservation;
      return {
        ...reservation,
        discountDecimal: discountPercentage / 100,
        rate: rate || { amount: 0, currency: currencyCode },
        userFirstName: userFirstName ?? undefined,
        userLastName: userLastName ?? undefined,
        venueId,
        venueName,
        venueSubtitle: venueSubtitle ?? undefined,
      };
    }),
    error,
    isLoaded: loaded,
    isLoading: loading,
  })
);
